import FooterElemInPC from '@rebuild/materials/shared/footer/FooterElemInPC.vue';

export const componentMap = {
	basic: FooterElemInPC
};
